__turbopack_context__.v({
  "bougie": "variant-chip-module__PLFYMG__bougie",
  "chip": "variant-chip-module__PLFYMG__chip",
  "classic": "variant-chip-module__PLFYMG__classic",
  "compact": "variant-chip-module__PLFYMG__compact",
  "quick": "variant-chip-module__PLFYMG__quick",
});
